import api from './api';
import { ProrationPreview, Subscription, SubscriptionHistoryItem } from '../types';

const mapSubscription = (sub: any): Subscription => ({
  id: sub._id,
  status: sub.status,
  startsAt: sub.startsAt,
  endsAt: sub.endsAt,
  cancelAtPeriodEnd: Boolean(sub.cancelAtPeriodEnd),
  plan: {
    id: sub.planId?._id,
    name: sub.planId?.name,
    slug: sub.planId?.slug,
    description: sub.planId?.description,
    price: sub.planId?.price,
    currency: sub.planId?.currency,
    billingInterval: sub.planId?.billingInterval,
    features: sub.planId?.features || [],
    monthlyLeadLimit: sub.planId?.monthlyLeadLimit,
    topUpAllowed: sub.planId?.topUpAllowed,
    earlyAccessMinutes: sub.planId?.earlyAccessMinutes,
    teamSeats: sub.planId?.teamSeats,
    canExport: sub.planId?.canExport,
    prioritySupport: sub.planId?.prioritySupport
  }
});

export const fetchMySubscription = async (): Promise<Subscription | null> => {
  const response = await api.get('/api/subscriptions/me');
  return response.data.subscription ? mapSubscription(response.data.subscription) : null;
};

/** Schedule cancellation at period end — access continues until endsAt. */
export const cancelSubscription = async (): Promise<Subscription | null> => {
  const response = await api.post('/api/subscriptions/cancel');
  return response.data.subscription ? mapSubscription(response.data.subscription) : null;
};

/** Undo a scheduled cancellation. */
export const resumeSubscription = async (): Promise<Subscription | null> => {
  const response = await api.post('/api/subscriptions/resume');
  return response.data.subscription ? mapSubscription(response.data.subscription) : null;
};

export const fetchSubscriptionHistory = async (): Promise<SubscriptionHistoryItem[]> => {
  const response = await api.get('/api/subscriptions/history');
  return response.data.history || [];
};

/** Wallet credits the driver would receive for unused days if switching plans now. */
export const fetchProrationPreview = async (): Promise<ProrationPreview> => {
  const response = await api.get('/api/subscriptions/proration-preview');
  return response.data;
};
